// Tooltip Messages
export const TOOLTIP_MESSAGES = {
    // Individual - Card
    WITHDRAWAL_TYPE: 'Choose whether to withdraw to a card or bank account',
    CURRENCY: 'Currency for the withdrawal',
    CARD_NUMBER: 'Enter the 16-digit card number where you want to receive funds',
    NAME_ON_CARD: 'Cardholder name as it appears on the card',
    AMOUNT_CARD: 'Amount you want to withdraw to your card',

    // Individual - Bank
    FIRST_NAME: 'First name of the account holder',
    LAST_NAME: 'Last name of the account holder',
    IBAN: 'International Bank Account Number or your local account number',
    SWIFT: 'SWIFT code or Bank Identifier Code for international transfers',
    RECIPIENT_COUNTRY: "Country where the recipient's bank account is located",
    TOWN_CITY: "Town or city of the recipient's address",
    POSTCODE: "Postal code for the recipient's address",
    RECIPIENT_ADDRESS: 'Complete street address of the recipient',
    AMOUNT_BANK: 'Amount you want to withdraw to the bank account',

    // Business
    BUSINESS_IBAN: 'International Bank Account Number or Account Number for the business',
    BUSINESS_SWIFT: 'Society for Worldwide Interbank Financial Telecommunication code or Bank Identifier Code',
    BUSINESS_NAME: 'Official registered name of your business',
    BUSINESS_COUNTRY: 'Country where your business is registered',
    BUSINESS_TOWN_CITY: 'Town or city where your business is located',
    BUSINESS_POSTCODE: 'Postal code for your business address',
    BUSINESS_ADDRESS: 'Complete street address of your business',
    AMOUNT_BUSINESS: 'Amount you want to withdraw to your business account',
    CURRENCY_BUSINESS: 'Currency for the withdrawal',
};

// Validation Rules
export const VALIDATION_RULES = {
    CARD_NUMBER: {
        MIN_LENGTH: 13,
        MAX_LENGTH: 19,
        PATTERN: /^[\d\s]+$/,
    },
    NAME: {
        MIN_LENGTH: 2,
        MAX_LENGTH: 50,
        PATTERN: /^[a-zA-Z\s\-']+$/,
    },
    IBAN: {
        MIN_LENGTH: 15,
        MAX_LENGTH: 34,
        PATTERN: /^[A-Z]{2}[0-9]{2}[A-Z0-9]+$/,
    },
    SWIFT: {
        MIN_LENGTH: 8,
        MAX_LENGTH: 11,
        PATTERN: /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/,
    },
    POSTCODE: {
        MIN_LENGTH: 3,
        MAX_LENGTH: 10,
        PATTERN: /^[A-Z0-9\s\-]+$/i,
    },
    AMOUNT: {
        MIN: 0.01,
        MAX: 1000000,
        PATTERN: /^\d*\.?\d{0,2}$/,
    },
    ADDRESS: {
        MIN_LENGTH: 5,
        MAX_LENGTH: 200,
    },
    CITY: {
        MIN_LENGTH: 2,
        MAX_LENGTH: 100,
        PATTERN: /^[a-zA-Z\s\-']+$/,
    },
    BUSINESS_NAME: {
        MIN_LENGTH: 2,
        MAX_LENGTH: 100,
    },
};

// Error Messages
export const ERROR_MESSAGES = {
    REQUIRED: 'This field is required',
    INVALID_CARD_NUMBER: 'Please enter a valid card number (13-19 digits)',
    INVALID_NAME: 'Please enter a valid name (letters, spaces, hyphens, and apostrophes only)',
    INVALID_IBAN: 'Please enter a valid IBAN (starts with 2 letters, followed by 2 digits)',
    INVALID_SWIFT: 'Please enter a valid SWIFT/BIC code (8 or 11 characters)',
    INVALID_POSTCODE: 'Please enter a valid postcode',
    INVALID_AMOUNT: 'Please enter a valid amount (0.01 - 1,000,000)',
    INVALID_ADDRESS: 'Address must be between 5 and 200 characters',
    INVALID_CITY: 'Please enter a valid city name',
    INVALID_BUSINESS_NAME: 'Business name must be between 2 and 100 characters',
    MIN_LENGTH: (min: number) => `Minimum ${min} characters required`,
    MAX_LENGTH: (max: number) => `Maximum ${max} characters allowed`,
    MIN_AMOUNT: (min: number) => `Minimum amount is ${min}`,
    MAX_AMOUNT: (max: number) => `Maximum amount is ${max}`,
};

// Placeholders
export const PLACEHOLDERS = {
    CARD_NUMBER: 'Enter the Card Number',
    NAME_ON_CARD: 'Enter the Name on Card',
    FIRST_NAME: 'Enter the First name',
    LAST_NAME: 'Enter the Last name',
    IBAN: 'Enter the IBAN / Account Number',
    SWIFT: 'Enter the SWIFT / BIC',
    RECIPIENT_COUNTRY: "Select a Recipient's country",
    TOWN_CITY: 'Enter the Town/City',
    POSTCODE: '000000',
    RECIPIENT_ADDRESS: "Enter the Recipient's address",
    AMOUNT: 'Enter the Amount',
    CURRENCY: 'USD',
    WITHDRAWAL_METHOD: 'Select withdrawal method',
    BUSINESS_NAME: 'Enter the Business name',
    BUSINESS_COUNTRY: "Select a Business's country",
    BUSINESS_ADDRESS: 'Enter the Business address',
};

// Individual form fields reset
export const INITIAL_INDIVIDUAL_FIELDS = {
    cardNumber: '',
    nameOnCard: '',
    firstName: '',
    lastName: '',
    ibanAccountNumber: '',
    swiftBic: '',
    recipientCountry: '',
    townCity: '',
    postcode: '',
    recipientAddress: '',
};

// Business form fields reset
export const INITIAL_BUSINESS_FIELDS = {
    businessIbanAccountNumber: '',
    businessSwiftBic: '',
    businessName: '',
    businessCountry: '',
    businessTownCity: '',
    businessPostcode: '',
    businessAddress: '',
};

// Card-specific fields reset
export const INITIAL_CARD_FIELDS = {
    cardNumber: '',
    nameOnCard: '',
};

// Bank account-specific fields reset
export const INITIAL_BANK_FIELDS = {
    firstName: '',
    lastName: '',
    ibanAccountNumber: '',
    swiftBic: '',
    recipientCountry: '',
    townCity: '',
    postcode: '',
    recipientAddress: '',
};

// Complete default form data
export const DEFAULT_FORM_DATA = {
    withdrawType: 'individual' as const,
    withdrawalMethod: 'card',
    firstName: '',
    lastName: '',
    ibanAccountNumber: '',
    swiftBic: '',
    recipientCountry: '',
    townCity: '',
    postcode: '',
    recipientAddress: '',
    cardNumber: '',
    nameOnCard: '',
    businessIbanAccountNumber: '',
    businessSwiftBic: '',
    businessName: '',
    businessCountry: '',
    businessTownCity: '',
    businessPostcode: '',
    businessAddress: '',
    amount: '',
    currency: 'USD',
};